import { InstagramFilled } from "@ant-design/icons";
import {
  PermissionsContentsType,
  QuickAccessType,
  SocialMediaContentsType,
} from "./types";

export const QuickAccessContents: QuickAccessType[] = [
  {
    id: 0,
    title: "درباره ما",
    url: "/about",
  },
  {
    id: 1,
    title: "خدمات",
    url: "/services",
  },
  {
    id: 2,
    title: "تماس با ما",
    url: "/contactus",
  },
  {
    id: 3,
    title: "قوانین و مقررات",
    url: "/rules",
  },
  {
    id: 4,
    title: "ثبت نام پیمانکاران",
    url: "https://installer.tabargh.com/login",
    isExternal: true,
  },
];

export const PermissionsContents: PermissionsContentsType[] = [
  {
    id: 0,
    title: "اتحادیه کشوری کسب و کارهای مجازی",
    url: "/assets/images/footer/ettehadie.png",
  },
  {
    id: 1,
    title: "سازمان نظام صنفی رایانه ای کشور",
    url: "/assets/images/footer/nazamsenfi.png",
  },
  {
    id: 2,
    title: "enamad",
    url: "/assets/images/footer/enamad.png",
  },
  {
    id: 3,
    title: "انجمن انرژی های تجدیدپذیر ایران",
    url: "/assets/images/footer/energyanjoman.png",
    link: "/doc/satka.pdf",
  },
  {
    id: 4,
    title: "satka",
    url: "/assets/images/footer/satka.png",
    mobileUrl: "/assets/images/footer/satkamobile.png",
  },
];

export const SocialMediaContents: SocialMediaContentsType[] = [
  {
    id: 0,
    name: "instagram",
    icon: <InstagramFilled className="!text-white text-2xl" />,
    url: "https://www.instagram.com/faranabenergy",
  },
];
